import { globalOnDemandVars } from '../../../helper/context'

export function getIdForRenderTileInJSON (uniqueId, initialPathForWindow1) {
  return JSON.stringify({
    id: uniqueId,
    path: initialPathForWindow1
  }
  )
}

export function generateNextInitialValue (current, pathMap, forPixel) {
  if (process.env.NODE_ENV !== 'production') {
    console.tron.display({
      name: 'generateNextInitialValue',
      preview: typeof current,
      value: {
        current,
        pathMap
      }
      // , important: true
    })
  }

  // globalOnDemandVars에서 localIdToGlobalID 할 수 있는지보고 그게 설정이 안된상태면 그냥 무.시.하기 - initialValue에 안넣기!! - pathMap을 map으로돌면서 temp로 시작하는거있음 그 앞까지만 slicing하면될듯
  let parsedPathMap
  if (!forPixel) {
    if (pathMap) {
      parsedPathMap = {}
      const keyArray = Object.keys(pathMap)
      for (let key of keyArray) {
        let pathOfOneWindow
        const pathMapElement = pathMap[key]
        if (typeof pathMapElement === 'string') {
          pathOfOneWindow = pathMapElement
        } else {
          pathOfOneWindow = Array.from(pathMapElement)
        }

        if (!(parsedPathMap[key])) {
          parsedPathMap[key] = pathOfOneWindow
        }
      }
    }

    if (process.env.NODE_ENV !== 'production') {
      console.tron.display({
        name: 'generateNextInitialValue 2',
        preview: typeof current,
        value: {
          current,
          pathMap,
          parsedPathMap
        }
      // , important: true
      })
    }
  }

  if (current) {
    let currentCopied, currentCopiedForGlobalId
    if (typeof current === 'object') {
      currentCopied = Object.assign({}, current)
      currentCopiedForGlobalId = Object.assign({}, current)
    } else {
      currentCopied = current
      currentCopiedForGlobalId = current
    }
    const dummyParent = {
      first: currentCopied
    }
    const dummyParentForGlobalId = {
      first: currentCopiedForGlobalId
    }

    const localRecursiveF = (node, parent, location, useGlobalId) => {
      if (typeof node === 'string') {
        const parsedNode = JSON.parse(node)
        const nodeId = parsedNode.id
        // const path = pathMap.get(nodeId)
        let path
        if (useGlobalId) {
          path = parsedPathMap[nodeId]
        } else {
          path = pathMap[nodeId]
        }
        // console.tron.display({
        //   name: 'generateNextInitialValue 2.75',
        //   preview: nodeId,
        //   value: {
        //     path,
        //     parsedPathMapOf: parsedPathMap[nodeId],
        //     pathMapOf: pathMap[nodeId],
        //     parsedPathMap,
        //     pathMap
        //   }
        //   // , important: true
        // })
        // const path = (useGlobalId ? parsedPathMap : pathMap)[nodeId]
        if (path) {
          parsedNode.path = path
          const newNode = JSON.stringify(parsedNode)
          if (location === 1) {
            parent.first = newNode
          } else {
            parent.second = newNode
          }
        }
      } else {
        localRecursiveF(node.first, node, 1, useGlobalId)
        localRecursiveF(node.second, node, 2, useGlobalId)
      }
    }

    // const modifiedDummyParent = produce(dummyParent, draft => {
    //   localRecursiveF(currentCopied, draft, 1)
    // })
    // const modifiedDummyParentForGlobalId = produce(dummyParentForGlobalId, draft => {
    //   localRecursiveF(currentCopiedForGlobalId, draft, 1, true)
    // })
    localRecursiveF(currentCopied, dummyParent, 1)
    if (!forPixel) { localRecursiveF(currentCopiedForGlobalId, dummyParentForGlobalId, 1, true) }

    if (!forPixel) {
      if (process.env.NODE_ENV !== 'production') {
        console.tron.display({
          name: 'generateNextInitialValue 2.5',
          value: {
          // forLocal: modifiedDummyParent.first,
          // forGlobal: modifiedDummyParentForGlobalId.first,
            dummyParent,
            dummyParentForGlobalId
          }
        // , important: true
        })
      }
    }

    if (!forPixel) { globalOnDemandVars.set_Window2InitialValueForGlobalId(dummyParentForGlobalId.first) }
    return dummyParent.first
  } else {
    if (!forPixel) { globalOnDemandVars.set_Window2InitialValueForGlobalId(null) }
    return current
  }
}

// TODO 테스트를 작성하기 시작하면 이런게 확실히 테스트 작성이 필요한 부분이다
// const uniqueId1 = uniqueId()
// const uniqueId2 = uniqueId()
// const dummyMap = new Map()
// dummyMap.set(uniqueId1, [1])
// dummyMap.set(uniqueId2, [2])
// const result = generateNextInitialValue({
//   direction: 'row',
//   first: getIdForRenderTileInJSON(uniqueId1, [3, 4]),
//   second: getIdForRenderTileInJSON(uniqueId2, [3, 4, 6])
// }, dummyMap
// )
//
// result
// dummyMap
